export const PRECIO_CONTROLES_MIN = 20000;
export const PRECIO_CONTROLES_SLIDER_MAX = 50000;
export const PRECIO_CONTROLES_STEP = 5000;
export const PRECIO_TELE_STEP = 5000;

export const PRECIO_CONTROLES_MAX_MEDICINA_FAMILIAR = 90000;
export const PRECIO_CONTROLES_MAX_MEDICINA_GENERAL = 60000;
export const PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL = 40000;

export function normalizeService(service) {
    if (!service) return '';
    return String(service).toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\d+/g, '')
        .replace(/_/g, ' ')
        .replace(/-/g, ' ')
        .trim();
}

export function getPrecioControlesRange(service) {
    if (!service) return { min: PRECIO_CONTROLES_MIN, max: 60000 };
    const s = normalizeService(service);
    if (s.includes('medicina familiar')) return { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_FAMILIAR };
    if (s.includes('medicina general')) return { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL };
    if (s.includes('terapia fisica') || s.includes('terapia de lenguaje') || s.includes('terapia lenguaje') || s.includes('terapeuta de lenguaje') ||
        s.includes('terapia ocupacional') || s.includes('terapeuta ocupacional') || s.includes('terapia respiratoria') || s.includes('terapeuta respiratorio') || s.includes('fisioterapeuta') || s.includes('fisioterapia')) {
        return { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL };
    }
    if (s.includes('psicologia') || s.includes('psicologo') || s.includes('trabajo social') || s.includes('nutricion') || s.includes('nutricionista') ||
        s.includes('enfermeria') || s.includes('enfermero') || s.includes('enfermera')) {
        return { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL };
    }
    return { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL };
}

const TELE_PRIMERA_VEZ_RANGES = {
    'medicina familiar': { min: 100000, max: 120000 },
    'medicina general': { min: 60000, max: 100000 },
    'terapia fisica': { min: 30000, max: 50000 },
    'terapia de lenguaje': { min: 30000, max: 50000 },
    'terapia lenguaje': { min: 30000, max: 50000 },
    'terapeuta de lenguaje': { min: 30000, max: 50000 },
    'terapia ocupacional': { min: 30000, max: 50000 },
    'terapeuta ocupacional': { min: 30000, max: 50000 },
    'terapia respiratoria': { min: 30000, max: 50000 },
    'terapeuta respiratorio': { min: 30000, max: 50000 },
    'fisioterapia': { min: 30000, max: 50000 },
    'fisioterapeuta': { min: 30000, max: 50000 },
    'psicologia': { min: 50000, max: 100000 },
    'psicologo': { min: 50000, max: 100000 },
    'trabajo social': { min: 50000, max: 100000 },
    'nutricion': { min: 50000, max: 100000 },
    'nutricionista': { min: 50000, max: 100000 },
    'enfermeria': { min: 50000, max: 100000 },
    'enfermero': { min: 50000, max: 100000 },
    'enfermera': { min: 50000, max: 100000 },
};

export function getTeleconsultaPrimeraVezRange(service) {
    const s = normalizeService(service);
    for (const [key, range] of Object.entries(TELE_PRIMERA_VEZ_RANGES)) {
        if (s.includes(key)) return range;
    }
    return { min: 30000, max: 100000 };
}

const PRECIOS_CONFIG_BY_SERVICE = {
    'medicina familiar': {
        teleconsultaPrimeraVez: { min: 100000, max: 120000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_FAMILIAR },
        precioTeleorientacion: 50000,
    },
    'medicina general': {
        teleconsultaPrimeraVez: { min: 60000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 45000,
    },
    'terapia fisica': {
        teleconsultaPrimeraVez: { min: 30000, max: 50000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL },
        precioTeleorientacion: 25000,
    },
    'terapia de lenguaje': {
        teleconsultaPrimeraVez: { min: 30000, max: 50000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL },
        precioTeleorientacion: 25000,
    },
    'terapia lenguaje': {
        teleconsultaPrimeraVez: { min: 30000, max: 50000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL },
        precioTeleorientacion: 25000,
    },
    'terapeuta de lenguaje': {
        teleconsultaPrimeraVez: { min: 30000, max: 50000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL },
        precioTeleorientacion: 25000,
    },
    'terapia ocupacional': {
        teleconsultaPrimeraVez: { min: 30000, max: 50000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL },
        precioTeleorientacion: 25000,
    },
    'terapeuta ocupacional': {
        teleconsultaPrimeraVez: { min: 30000, max: 50000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL },
        precioTeleorientacion: 25000,
    },
    'terapia respiratoria': {
        teleconsultaPrimeraVez: { min: 30000, max: 50000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL },
        precioTeleorientacion: 25000,
    },
    'terapeuta respiratorio': {
        teleconsultaPrimeraVez: { min: 30000, max: 50000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_TERAPEUTA_OCUPACIONAL },
        precioTeleorientacion: 25000,
    },
    'psicologia': {
        teleconsultaPrimeraVez: { min: 50000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 25000,
    },
    'psicologo': {
        teleconsultaPrimeraVez: { min: 50000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 25000,
    },
    'trabajo social': {
        teleconsultaPrimeraVez: { min: 50000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 25000,
    },
    'nutricion': {
        teleconsultaPrimeraVez: { min: 50000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 25000,
    },
    'nutricionista': {
        teleconsultaPrimeraVez: { min: 50000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 25000,
    },
    'enfermeria': {
        teleconsultaPrimeraVez: { min: 50000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 25000,
    },
    'enfermero': {
        teleconsultaPrimeraVez: { min: 50000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 25000,
    },
    'enfermera': {
        teleconsultaPrimeraVez: { min: 50000, max: 100000 },
        precioControles: { min: PRECIO_CONTROLES_MIN, max: PRECIO_CONTROLES_MAX_MEDICINA_GENERAL },
        precioTeleorientacion: 25000,
    },
};

export function getPreciosConfigByService(service) {
    if (!service) return null;
    const serviceNormalized = normalizeService(service);
    for (const [key, config] of Object.entries(PRECIOS_CONFIG_BY_SERVICE)) {
        if (serviceNormalized.includes(key)) return config;
    }
    return null;
}

export function requiereConfiguracionPrecios(service) {
    return getPreciosConfigByService(service) !== null;
}
